import React from 'react'
import { AddMedicalHistory as AddMedicalHistoryForm } from '../components/AddMedicalHistory'
import { NavigationBar } from '../components/NavigationBar'

export function AddMedicalHistory() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <NavigationBar />
      <div className="max-w-4xl mx-auto py-12 px-4">
        <AddMedicalHistoryForm />
      </div>
    </div>
  )
} 